<mat-card class="careers-card">
  <mat-card-header class="careers-header">
    <mat-card-title>Careers to explore</mat-card-title>
  </mat-card-header>

  <mat-divider></mat-divider>

  <mat-nav-list class="careers-list" aria-label="Careers to explore">
    @for (c of careers(); track c.id) {
      <mat-list-item class="career-item" (click)="openPage(c)">
        <div class="career-icon tech" matListItemIcon aria-hidden="true">{{ c.icon }}</div>
        <span matListItemTitle>{{ c.name }}</span>
        <span matListItemLine>{{ c.tagline }}</span>
      </mat-list-item>

      <mat-divider></mat-divider>
    }
  </mat-nav-list>

  <mat-divider></mat-divider>

  <mat-card-actions class="careers-footer">
    <a mat-button routerLink="/careers" class="footer-link" aria-label="See all career paths"
      >See all career paths →</a
    >
  </mat-card-actions>
</mat-card>
